export const DELIVERY_MODES = ['in_person', 'online', 'hybrid'] as const;

export type DeliveryMode = (typeof DELIVERY_MODES)[number];

export const DELIVERY_MODE_LABELS: Record<DeliveryMode, string> = {
  in_person: 'In Person',
  online: 'Online',
  hybrid: 'Hybrid',
};

export function isDeliveryMode(value: string | null | undefined): value is DeliveryMode {
  return typeof value === 'string' && DELIVERY_MODES.includes(value as DeliveryMode);
}

export function requiresLocalityForDeliveryMode(deliveryMode: DeliveryMode): boolean {
  return deliveryMode === 'in_person' || deliveryMode === 'hybrid';
}

export function supportsOnlineVisibility(deliveryMode: DeliveryMode): boolean {
  return deliveryMode === 'online' || deliveryMode === 'hybrid';
}
